import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import type { VillaHostInfoItem } from "../villa-host.types";
export const VillaHostInfoCards = t0 => {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="my-9 flex">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(item, index) {
  return <div key={item.title} className="flex items-center"><div className="flex items-center gap-3 lg:gap-4"><div className="bg-transparent-secondary rounded-lg p-3"><MaterialIcon name={item.icon} className="text-on-surface-secondary-high-emphasis text-headline-5 size-6" /></div><div><p className="text-base font-extrabold">{numberConvert(numberSeparator(item.value), {
            locale: "fa"
          })}{" "}+</p><p className="text-extra-caption text-on-surface-medium-emphasis w-max">{item.title}</p></div></div>{index === 0 && <div className="bg-states-neutral-focus mx-4 h-10 w-px border lg:mx-6" />}</div>;
}